import { PartsTransactionFieldsFragment } from 'src/pages/BulkCompliancePageV2/queries'

export const DELETE_PARTS_TRANSACTION = gql`
  mutation DeletePartsTransaction($id: String!) {
    deletePartsTransaction(id: $id) {
      id
    }
  }
`

export const UPSERT_PARTS_TRANSACTION = gql`
  ${PartsTransactionFieldsFragment}
  mutation UpsertPartsTransactionForWorkflowPartsTransactionSection(
    $id: String
    $input: UpsertPartsTransactionInput!
  ) {
    upsertPartsTransaction(id: $id, input: $input) {
      ...PartsTransactionFields
    }
  }
`

export const SEARCH_INVENTORY_PARTS = gql`
  query SearchInventoryPartsV2($search: String) {
    products(
      filters: {
        serialNumber: $search
        partNumber: $search
        name: $search
        matchAny: true
      }
    ) {
      id
      name
      partNumber
      inventoryItems {
        id
        status
        serialNumber
        condition
      }
    }
  }
`
